import { Dispatch } from "redux";
import {
  GLOBAL_SETTINGS,
  LOG_OUT,
  SET_CURRENT_USER,
  SET_DRAWER_LOADING,
  SET_I18N_LOADING,
  SET_IMPERSONATION_DATA,
  SET_LANGUAGES_LIST,
  SET_LOADING,
} from "../constants/actions";
import { privateApi, publicApi } from "../utils/api";
import refreshToken from "./refreshToken";
import { CountriesEntities } from "../utils/react";
import { DefaultRouteNames, RouteURLsByLanguage } from "../routes";
import { getTenantFromUrl } from "../utils";

export interface Action {
  type: string;
  payload?: any;
}

export const setLanguageItemsList = (value): Action => ({
  type: SET_LANGUAGES_LIST,
  payload: value,
});

export const setI18NLoading = (value): Action => ({
  type: SET_I18N_LOADING,
  payload: value,
});
export const setLoading = (value): Action => ({
  type: SET_LOADING,
  payload: value,
});

export const setDrawerLoading = (value): Action => ({
  type: SET_DRAWER_LOADING,
  payload: value,
});

export const logOutLocally = (): Action => ({
  type: LOG_OUT,
});

export const globalSettingsFetch = async (payload) => {
  const response = await publicApi.get(`globalsettings/`, {
    params: {
      tenantName: payload,
    },
  });

  return response;
};

export const checkIfTenantIsValid = async (payload) => {
  try {
    const response = await publicApi.get(`isvalidtenantcode/`, {
      params: {
        tenantName: payload,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

export const globalSettings = (payload) => {
  return async function (dispatch: Dispatch) {
    try {
      const response = await globalSettingsFetch(payload);

      dispatch({ type: GLOBAL_SETTINGS, payload: response.data.data });
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};

export const current = () => {
  return async function (dispatch: Dispatch) {
    try {
      const response = await privateApi.get("users/current/profile/");
      dispatch({ type: SET_CURRENT_USER, payload: response.data.data });
      dispatch({
        type: SET_IMPERSONATION_DATA,
        payload: response.data.meta.impersonationBox,
      });
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};

export const getSimulatorUrl = (currentUrl: string) => {
  return async function () {
    try {
      const response = await privateApi.get(`pages/${currentUrl}`);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};

export const changeCurrentUserLanguage = (newLanguage: string) => {
  return async function () {
    try {
      const response = await privateApi.put(
        `users/current/changemylanguage?newLanguage=${newLanguage}`
      );
      if (response.status === 200) {
        setTimeout(function () {
          refreshToken(null);
          window.open(
            `${window.location.origin}${
              RouteURLsByLanguage[
                `${DefaultRouteNames.DASHBOARD}-${newLanguage}`
              ]
            }`,
            "_self"
          );
        }, 2000);
      }
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};

export const fetchCountriesList = (
  language: number
): ((_dispatch: any) => Promise<CountriesEntities[]>) => {
  return async (_dispatch: any) => {
    try {
      const response = await privateApi.get(
        `enumerator/countries?language=${language}`
      );
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};
